export default "__VITE_ASSET__1bci3vat__"